import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import ServiceCaller from '@/libs/service-caller/service-caller-vue';
import Loader from '@/components/common/modals/Loading';
import ErrorModal from '@/components/common/modals/ErrorModal';
import SuccessModal from '@/components/common/modals/SuccessModal';
import YesNoModal from '@/components/common/modals/YesNoModal';
import ProceedModal from '@/components/common/modals/ProceedModal';

Vue.config.productionTip = false

var configURL = "config.json?" + new Date();

// CHANGE TO THE HOSTED API SERVER ADDRESS
// var data = {
//   "ServerAddress": "https://demo.devinspire.co.za/SuburbanServ/api/api/"
// }
// var data = {
//   "ServerAddress": "http://localhost:9903/SuburbanServ/api/"
// }

fetch(configURL).then(r => r.json()).then(data => {
  sessionStorage["Config"] = JSON.stringify(data);
  localStorage["Config"] = JSON.stringify(data);
  Vue.prototype.$Config = data;
  Vue.use(ServiceCaller, data, store);
  Vue.component('Loader', Loader);
  Vue.component('ErrorModal', ErrorModal);
  Vue.component('SuccessModal', SuccessModal);
  Vue.component('YesNoModal', YesNoModal);
  Vue.component('ProceedModal', ProceedModal);

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
